import { render, staticRenderFns } from "./inviteModal.vue?vue&type=template&id=1dfde00a&scoped=true"
import script from "./inviteModal.vue?vue&type=script&lang=js"
export * from "./inviteModal.vue?vue&type=script&lang=js"
import style0 from "./inviteModal.vue?vue&type=style&index=0&id=1dfde00a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfde00a",
  null
  
)

export default component.exports